/*
================================================
Une mixin pour la gestion des devises
================================================
*/

var CurrencyMixin = {
    // created() {
    // },

    // data: function () {
    //     return {}
    // },
    methods: {
        /**
         * Convertit une devise au format iso 4217 en un symbole (ex :'EUR' => "€", "USD"=>"$). Retourne seulement un symbole pour quelques devises les plus courantes. Pour les devises les moins courantes "currency" est retourné tel quel.
         * @param currency Devise au format iso 4217
         * @see WorkspaceSettingCurrencyComp
         */
        currencyToSign(currency){

            switch (currency) {
                case  'EUR': return '€' ; break;
                case  'USD': return '$' ; break;
                case  'GBP': return '£' ; break;
                case  'JPY': return '¥' ; break;
                default: currency; break;
            }
        }
    },
}

export default CurrencyMixin;
